import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import APIcon from '../common/APIcon';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import path from '../../helpers/path';
import './VerificationRequiredComponent.css';
var VerificationRequiredComponent = function VerificationRequiredComponent(props, context) {
  var customClass = props.customClass,
    className = props.className,
    disabled = props.disabled,
    isUnderReview = props.isUnderReview,
    verificationLevelPageUrl = props.verificationLevelPageUrl,
    enableOnClick = props.enableOnClick,
    onVerificationLinkClick = props.onVerificationLinkClick,
    _onClick = props.onClick,
    customKYCmessage = props.customKYCmessage,
    history = props.history,
    disableKYCLinkUnderReview = props.disableKYCLinkUnderReview;
  var noLink = disableKYCLinkUnderReview ? isUnderReview : verificationLevelPageUrl === '';
  var bemClasses = getBEMClasses(['verification-required', customClass]);
  var handleOnVerificationLinkClick = function handleOnVerificationLinkClick() {
    if (verificationLevelPageUrl.match(/^http/)) {
      window.location.href = verificationLevelPageUrl;
    } else {
      history.push(path(verificationLevelPageUrl));
      if (enableOnClick) onVerificationLinkClick();
    }
  };
  if (disabled) return React.createElement('div', {
    className: bemClasses('container')
  }, React.createElement('div', {
    className: bemClasses(noLink ? 'no-link' : ''),
    onClick: function onClick() {
      if (noLink) return;
      handleOnVerificationLinkClick();
      _onClick && _onClick();
    }
  }, React.createElement(APIcon, {
    name: 'alert',
    customClass: bemClasses('warning'),
    classModifiers: 'small'
  }), React.createElement('span', {
    className: 'ap--label ' + bemClasses('not-verified') + ' ' + className
  }, customKYCmessage ? customKYCmessage : getVerificationRequiredMessage(context, isUnderReview, noLink))));
  return null;
};
var getVerificationRequiredMessage = function getVerificationRequiredMessage(context, isUnderReview, noLink) {
  if (noLink && isUnderReview) return context.t('You are not yet verified. Verification under review.');else if (noLink) return context.t('You are not yet verified. Verify your identity to start trading.');else if (isUnderReview) return context.t('Verification under review. Click here to check your verification status.');else return context.t('Verify your identity to start trading. Click here to verify.');
};
VerificationRequiredComponent.defaultProps = {
  className: '',
  onVerificationLinkClick: function onVerificationLinkClick() {},
  isUnderReview: false,
  disabled: false,
  enableOnClick: true,
  disableKYCLinkUnderReview: false
};
VerificationRequiredComponent.propTypes = {
  className: PropTypes.string,
  verificationLevelPageUrl: PropTypes.string.isRequired,
  onVerificationLinkClick: PropTypes.func.isRequired,
  isUnderReview: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  enableOnClick: PropTypes.bool,
  customKYCmessage: PropTypes.string
};
VerificationRequiredComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default withRouter(VerificationRequiredComponent);